// This file prevents logged-in tenants from accessing the admin login page
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../hooks/AdminAuthProvider";

const AdminLoginGuard = ({ children }) => {
  const { isAdminTokenValid } = useAdminAuth();
  const tenant = localStorage.getItem("tenant");

  if (tenant) return <Navigate to="/login" replace />;
  if (isAdminTokenValid()) return <Navigate to="/admin-dashboard" replace />;

  return children;
};

export default AdminLoginGuard;
